<template>
  <div class="main-container">

    <div class="content mt-4 section-space--ptb_120">
      <div class="container">
        <h1 class="text-center mb-4 ">MHP Finance-Estate Beteiligungen UG (Haftungsbeschränkt)</h1>
        <h2 class="title text-center mb-20">Impressum</h2>
        <h6 class="mb-20">Angaben gemäß § 5 TMG</h6>
        <ul class="mb-20">
          <li>
          </li>
          <li> Schillerstraße 74
          </li>
          <li> 16341 Panketal
          </li>
          <li> Handelsregister: HRB 17635 FF
          </li>
          <li> Registergericht: Amtsgericht Frankfurt (Oder)
          </li>
        </ul>

        <h6>Vertreten durch:</h6>
        <p>Pelz, Thorsten</p>

        <h6 class="mt-20">Kontakt</h6>
        <ul>
          <li> Telefon: 0151 248 711 05 E-Mail: info@mhp-finance.de
          </li>
        </ul>

        <h6 class="mt-20">EU-Streitschlichtung</h6>
        Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:
        https://ec.europa.eu/consumers/odr. Unsere E-Mail-Adresse finden Sie oben im Impressum.

        <h6 class="mt-20">Verbraucherschlichtung</h6>
        ‍Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
      </div>
    </div>

    <FooterMain/>
  </div>
</template>

<script>
import FooterMain from '@/components/FooterMain'

export default {
  name: 'Imprint',
  components: {
    FooterMain
  }
}
</script>